// Выбор отрезков редактора маршрута: тап по отрезку добавляет его к
// выделению, повторный тап по выделенному снимает, тап мимо отрезков
// сбрасывает всё. Порядок не важен - храним по возрастанию, чтобы
// сравнения и подсветка были стабильными.
export const toggleLegSelection = (selected: readonly number[], tapped: number | null): number[] => {
  if (tapped == null) return [];
  if (selected.includes(tapped)) return selected.filter((i) => i !== tapped);
  return [...selected, tapped].sort((a, b) => a - b);
};

// После правки линии (стёрли вершину, отменили действие) отрезков может
// стать меньше - выбор не должен указывать в пустоту.
export const clampLegSelection = (selected: readonly number[], legCount: number): number[] =>
  selected.filter((i) => i >= 0 && i < legCount);
